// SPDX-License-Identifier: Apache-2.0

import { jsonArrayMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";
import PerunMessage from "./PerunMessage";

@jsonObject()
export default class FundingChannelFound extends PerunMessage {
  @jsonArrayMember(String)
  channelIDs!: string[];

  constructor(channelIDs: string[]) {
    super();
    this.channelIDs = channelIDs;
  }
  messageType(): MessageType {
    return FundingChannelFound;
  }
  messageTypeName(): MessageTypeName {
    return "FundingChannelFound";
  }
}
